import clsx from 'clsx'
import { type HTMLAttributes, forwardRef, type ElementType } from 'react'

type ScrollAreaProps = HTMLAttributes<HTMLElement> & { as?: ElementType }

const ScrollArea = forwardRef<HTMLElement, ScrollAreaProps>((props, ref) => {
    const { className, as: Component = 'div', ...otherProps } = props
    return (
        <Component
            className={clsx(
                'overflow-y-auto overflow-x-hidden [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-neutral-300 dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-neutral-100 dark:[&::-webkit-scrollbar-track]:bg-neutral-700 [&::-webkit-scrollbar]:w-2',
                className,
            )}
            {...otherProps}
            ref={ref}
        />
    )
})

ScrollArea.displayName = 'ScrollArea'

export { ScrollArea, type ScrollAreaProps }
